module.exports = __webpack_public_path__ + "static/img/station02.3318f9e5.png";